export default __webpack_public_path__ + "static/media/UI_Button_GB.bf81f694.mp3";